<template>
  <!-- <div class="header"> -->
  <div :class="headerName? 'header': 'header-index'">
    <img v-show="$route.path!=='/'" src="~imgs/head-search-bg.png" alt="" class="header-bg">
    <img v-show="$route.path ==='/'" src="~imgs/index-header-bg.png" alt="" class="header-bg">
    <div class="home-header">
      <div class="logo-wrapper">
        <a class="logo_url" href="http://www.wanfangdata.com.cn" target="_blank"><img src="~imgs/logo-WF.png" alt=""></a>
        <span>中国戏曲志资源数据库</span>
      </div>
      <div class="login-wrapper" v-if="userinfo.users">
        <span class="item-li user-group" v-if="userinfo.users.length > 0">
            {{
              userinfo.users[0].institution.length > 6
                ? userinfo.users[0].institution.slice(0, 6) + '...'
                : userinfo.users[0].institution
            }}
          <ul class="userInfo-wrapper" >
            <li v-show="index != 0" v-for="(item, index) of userinfo.users" :key="index">{{item.institution}}</li>
          </ul>
        </span>
        <span class="item-li"><a @click ="handleClickLogin">登录</a></span>
        <span class="item-li"><a @click="handleClickLoginOut" v-if="userinfo">退出</a></span>
      </div>
      <div class="nav-wrapper" @click="handleClearSearch">
        <router-link to='/' :class="{'item-li' : true, 'active': showFontStyle}" >首页</router-link>
        <a @click="handleClickToCategory" :class="{'item-li' : true, 'active': !showFontStyle}">分类导航</a>
      </div>
    </div>
    <div :class="headerName?'box-search':'box-search-index'" key="search-page">
      <img src="~imgs/index-title.png" alt="" v-show="$route.path ==='/'">
      <div class="search-wrapper">
      <div class="range">
        <i class="selected-arrow-icon" @click="handleMouseEnter"></i>
        <div 
          class="selected" 
          @click="handleMouseEnter"
          >{{selectedValue}}
        </div>
        <div class="select-list" v-show="showList" @mouseleave="mouseShowList">
          <span class="Content" @click="handleClickSelect($event)">正文</span>
          <span class="Title" @click="handleClickSelect($event)">题名</span>
          <span class="BookTitle" @click="handleClickSelect($event)">志书名</span>
          <span class="Editor" @click="handleClickSelect($event)">编纂人员</span>
          <span class="Editorial" @click="handleClickSelect($event)">编纂单位</span>
          <span class="Publisher" @click="handleClickSelect($event)">出版单位</span>
          
        </div>
      </div>
      <div class="box-keywords">
        <input type="text" 
          class="keywords" 
          :readonly="readonlyShow"
          @focus="focusHandle" 
          @keyup.enter="handleSearch"
          v-model="queryWords"
          placeholder="请输入检索词"/>
        <button 
          class="search-btn" 
          @click="handleSearch"><img src="~imgs/search-btn.png" alt="">
        </button>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {LOGIN_OUT_URL, RESOURCE_TYPE_ITEM_DOWN, READ_URL, RESOURCE_TYPE_ITEM_READ, LOGIN_IN_URL, RESOURCE_TYPE_READ} from '../store/mutation-types'
export default {
  name: 'PageHeader', 
  data () {
    return {
      queryWords: '',
      showList: false,
      selectedValue: '正文',
      querySelect: 'Content',
      headerName: false,
      queryInfo: '',
      showFontStyle: true,
      typeEnObj: {
        Content: '正文',
        Title: '题名',
        BookTitle: '志书名',
        Editor: '编纂人员',
        Editorial: '编纂单位',
        Publishe: '出版单位'
      },
      readonlyShow: true
    }
  },
  mounted () {
    if(this.$route.path ==='/') {
      this.headerName = false
      this.showFontStyle = true
    }else {
      this.headerName = true
    }
  },
  computed: {
    ...mapState(['userinfo', 'book_id', 'upCouter', 'readingType'])
  },
  methods: {
    // 设置cookie值
    setCookie(cname, cvalue) {
      var d = new Date();
      d.setTime(d.getTime() + ( 30 * 60 * 1000));
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires + ';path=/;domain=wanfangdata.com.cn';
    },
    getUserInfo() {
      this.$http.get('/api/v1/users?'+new Date().getMilliseconds()).then((res) => {
        if(res.status===200 && res.data) {
          const data = res.headers.cookie
          if(data != undefined) {
             this.setCookie("CASTGC", data)
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },


    // 登录
    handleClickLogin () {
      const urlinner = window.location.href
      const inner = window.encodeURIComponent(urlinner)
      const url = LOGIN_IN_URL + inner
      window.location.href = url
    },
    handleClickLoginOut () {
      const urlinner = window.location.origin + '/' + window.location.pathname.split('/')[1];
      const inner = encodeURIComponent(urlinner);
      const url = LOGIN_OUT_URL + inner
      window.location.href = url;
    },
    async handleClickToCategory () {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$router.push({path: 'category', query: {sortType: 'BookTitle', pageNo: 1}})
        this.showFontStyle = false
      }
    },
    handleClearSearch () {
      this.queryWords = ''
    },
    mouseShowList () {
       this.showList = false
    },
    handleClickSelect (e) {
      const content = e.target.innerText
      this.selectedValue = content
      this.showList = false
      this.querySelect = e.target.className
    },
    handleMouseEnter (e) {
      if (e) {
        this.showList = !this.showList
      }
    },
    handleMouseLeave (e) {
        this.showList = !this.showList
    },
    // 检索
    handleSearch (e) {
      let queryInfo= ''
      if(this.queryWords) {
        queryInfo = (this.querySelect + ":" + this.queryWords.trim());
      }
      if((this.queryWords).trim() === '') {
        alert('请输入检索词')
        return
      }
      this.$emit('handleClickSearch', queryInfo)
      this.$router.push({path: 'search', query: {query: queryInfo}})
    },
    // 清空检索条件
    _clearSearchParam () {
      if(this.$route.path !=='/search') {
        this.$store.dispatch('savaFilterList', [])
        this.$store.dispatch('savaFilterQuery', [])
      }
    },
    //切换页头
    changeHeader () {
      if(this.$route.path ==='/') {
        this.headerName = false
      }else {
        this.headerName = true
      }

      this.$store.dispatch('getUserInfo')
    },
    // 同步输入框
    _initSearchBox () {
      let keyWord = this.$route.query.query
      if(keyWord) {
        this.queryWords = keyWord.split(':')[1]
      }else {
        this.queryWords = ''
      }
    },
    // 同步检索类型
    _initSearchType () {
      const selectType = this.$route.query.query
      if (selectType) {
        const typeEn = selectType.split(":")[0]
        this.selectedValue = this.typeEnObj[typeEn]
      }
    },
    // 刷新页面跳转阅读页
    _initToReading () {
      if(!this.$route.query.service) {
        return
      }
      if(this.upCouter && this.book_id && this.readingType === 1) {
        window.open(READ_URL + this.book_id + RESOURCE_TYPE_ITEM_READ)
      }
      if (this.upCouter && this.book_id && this.readingType === 2){
        window.open(READ_URL + this.book_id + RESOURCE_TYPE_READ)
      }
      if (this.upCouter && this.book_id && this.readingType === 3){
        window.location.href = READ_URL + this.book_id + RESOURCE_TYPE_ITEM_DOWN
      }
    },
    // 判断用户是否登录
    _isLogin () {
      let counter = 0
      this.$store.dispatch('saveCurrentBookId', counter)
      this.$store.dispatch('saveCounter', counter)
    },
    async focusHandle () {
      this.readonlyShow = true
      if (await this.$loginAuthentication.intercept(1)) {
        this.readonlyShow = false
      } else {
        this.$message.warning('请先登录账号！')
      }
    }
  },
  created () {
    this.getUserInfo()
    this.$store.dispatch('getUserInfo')
  },
  watch: {
    $route: {
      handler: function(val){
        if(this.$route.path ==='/') {
          this.headerName = false
          this.showFontStyle = true
        }else {
          this.headerName = true
        }
        // 清空检索条件
        this._clearSearchParam() 
      },
      // 深度观察监听
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@topic-color: #94491f;
@area-color :#d96815;
@line-color: #ece4df;
.home-header {
  .login-wrapper {
    height: 32px;
    display: flex;
    a:hover {
      transform: scale(1.1);
    }
  }
}
.user-group:hover {
  .userInfo-wrapper {
    display: block
  }
}

.userInfo-wrapper {
  span {
    &:hover {
      transform: scale(1.1);
      opacity: .8;
    }
  }
  
  li {
    padding: 0 30px;
    width: 135px;
    height: 43px;
    line-height: 43px;
    text-align: center;
    font-size: 14px;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #94491f;
  }
  li:hover {
    background: #f8f5f4;
  }
}
.userInfo-wrapper {
    display: none;
    user-select: none;
    background: #fff;
    padding: 4px;
  }
.header-index{
  //height: 498px;
  //overflow: hidden;
  width: 100%;
  height: 0;
  padding-bottom: 26%;
  border-top: 32px solid #b01e23;
  background: url(~imgs/lantern.png) no-repeat center;
  background-position: top;
  .header-bg{
    width: 100%;
    z-index: -1;
    position: absolute;
  }
}
.header{
  overflow: hidden;
  width: 100%;
  height: 219px;
  border-top: 20px solid #b01e23;
  background: url(~imgs/top-border-bg.png) repeat-x;
  background-position: top;
  .header-bg{
    height: 239px;
    z-index: -2;
    position: absolute;
    margin-top: -20px;
    width: 100%;
  }
  border-bottom: 1px solid #dbcfc8;
}
.box-search{
  position: absolute;
  left: 50%;
  top: 138px;
  margin-left: -419px;
  text-align: center;
  z-index: 1;
  img{
    margin-bottom: 45px;
  }
  .search-wrapper{
    margin: 0 auto;
    box-sizing: border-box;
    height: 52px;
    width: 838px;
    border-radius: 5px;
    border: 1px solid #dbcfc8;
    background-color: #ffffff;
    .range{
      float: left;
      line-height: 52px;
      position: relative;
      color: #333;
      cursor: pointer;
      .selected{
        width: 120px;
        font-size: 16px
      }
      .select-list span{
        display: block;
        width: 120px;
        line-height: 52px;
        cursor: pointer;
        &:hover{
          background-color: #f2eeeb;
        }
      }
      .select-list{
        position: absolute;
        z-index: 1;
        border: 1px solid #dbcfc8;
        background: #fff;
        color: #333;
        font-size: 14px;
      }
      .selected-arrow-icon{
        right: 15px;
        top: 50%;
        border-width:5px;
        border-color: #b78264 transparent  transparent   transparent ;
        border-style:solid dashed dashed  dashed  ;
        position: absolute;
        // top: 28px;
        // left: 110px;
      }
    }
    .box-keywords{
      float: right;
      box-sizing: border-box;
      .search-btn{
        background: none;
        border: none;
        cursor: pointer;
        img{
          margin-bottom: 0;
          vertical-align: middle;
          padding-right: 20px;
        }
      }
      input{
        height: 50px;
        width: 638px;
        line-height: 50px;
        border: none;
        font-size: 16px;
        //padding-left: 40px;
      }
    }
  }
}

.home-header{
  width: 1200px;
  margin: 0 auto;
  height: 32px;
  line-height: 32px;
  padding-top: 50px;
  position: relative;
  z-index: 2;
  .logo-wrapper{
    float: left;
    img{
      vertical-align: middle;
      padding: 0 18px 0 11px;
    }
    span{
      font: 32px "STXingkai";
      color: @topic-color;
      vertical-align: middle;
    }
  }
  .nav-wrapper{
    float: right;
    padding-right: 14px;
    display: inline-block;
    a {
      cursor: pointer;
    }
    .item-li{
      float: left;
      color: @topic-color;
      padding: 0 30px;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
        opacity: .8;
      }
      &.active {
        font-weight: bold;
      }
    }
    
  }
  .login-wrapper {
      float: right;
      color: @topic-color;
      cursor: pointer;
      a {
        color: @topic-color;
        &:hover {
         transform: scale(1.1);
        }
      }
      .item-li {
        padding: 0 30px;
        position: relative;
        //width: 100px;
        display: inline-block;
        &:hover {
          transform: scale(1.1);
          opacity: .8;
        }
        &.active {
          font-weight: bold;
        }
      }
      .userInfo-wrapper {
        position: absolute;
        left: -16px;
        z-index: 1;
      }
    }
}

.box-search-index{
    text-align: center;
    margin-top: 116px;
    img{
      margin-bottom: 45px;
    }
    .search-wrapper{
      margin: 0 auto;
      box-sizing: border-box;
      height: 60px;
      width: 838px;
      border-radius: 5px;
      border: 1px solid #dbcfc8;
      background-color: #ffffff;
      .range{
        float: left;
        line-height: 60px;
        position: relative;
        color: #333;
        &:hover {
          cursor: pointer;
        }
        .selected{
          width: 120px;
          font-size: 16px
        }
        .select-list span{
          display: block;
          width: 120px;
          line-height: 40px;
          cursor: pointer;
          &:hover{
            background-color: #f2eeeb;
          }
        }
        .select-list{
          position: absolute;
          z-index: 1;
          border: 1px solid #dbcfc8;
          background: #fff;
          color: #333;
          font-size: 14px;
        }
        .selected-arrow-icon{
          border-width:5px;
          border-color: #b78264 transparent  transparent   transparent ;
          border-style:solid dashed dashed  dashed  ;
          position: absolute;
          top: 28px;
          left: 98px;
        }
      }
      .box-keywords{
        float: right;
        box-sizing: border-box;
        .search-btn{
          background: none;
          border: none;
          cursor: pointer;
          img{
            margin-bottom: 0;
            vertical-align: middle;
            padding-right: 20px;
          }
        }
        input{
          height: 58px;
          width: 640px;
          border: none;
          font-size: 16px;
        }
      }
    }
  }

  @media screen and (max-width: 1440px) {
    .box-search-index{
      margin-top: 54px;
      .search-wrapper {
        width: 680px;
        .box-keywords {
          width: 558px;
          input {
            width: 480px;
            padding-left: 13px;
          } 
        }
      }
    }
}

@media screen and (max-width: 1366px) {
  .header-index{
    background-position-y: 10px;
    .top{
      padding-top: 50px;
    }
    .box-search-index{
      margin-top: 48px;
    }
  }
}

@media screen and (max-width: 1280px) {
  background-position-y: 8px;
  .header-indexr{
    .top{
      padding-top: 50px;
    }
    .box-search-index{
      margin-top: 48px;
      .search-wrapper{
        width: 640px;
        .box-keywords{
          input{
            width: 412px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/common/PageHeader.vue